import { render, staticRenderFns } from "./projectReviewGcTab.vue?vue&type=template&id=812a5a9c&"
import script from "./projectReviewGcTab.vue?vue&type=script&lang=js&"
export * from "./projectReviewGcTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports